import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import NewsList from "../pages/NewsList";
import About from "../pages/About";
import Players from "../pages/Players";
import PlayerRegister from "../pages/PlayerRegister";
import Gallery from "../pages/Gallery";
import PlayerRegisterSuccess from "../pages/PlayerRegisterSuccess";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/news" element={<NewsList />} />
      <Route path="/about" element={<About />} />
      <Route path="/players" element={<Players />} />
      <Route path="/players/register" element={<PlayerRegister />} />
      <Route path="/register-success" element={<PlayerRegisterSuccess />} />
      <Route path="/gallery" element={<Gallery />} />
    </Routes>
  );
}